import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSidebarLong = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 0C2.44772 0 2 0.447715 2 1V14C2 14.5523 2.44771 15 3 15H12C12.5523 15 13 14.5523 13 14V1C13 0.447715 12.5523 0 12 0H3ZM9 2H4V13H9V2Z",
		fill: "currentColor"
	})
});
export default SvgIconSidebarLong;
